import { render } from "./BaseLayout.vue?vue&type=template&id=787537e3"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"
script.render = render

export default script